import { useMemo } from "react";

import { isConditionSpecialFunc } from "../../utils/isConditionSpecialFunc";

import { FilterConditionOperation } from "../../components/LayerFilter/types";
import { FilterCondition } from "../../evergis/core/condition/FilterCondition";
import { LayerInfo } from "../../interfaces/resourceInfo";

export const useLayerConditionCount = (layer: LayerInfo): string | undefined => {
  const conditionSplit = useMemo(() => layer.condition?.split(FilterConditionOperation.AND) ?? [], [layer]);
  const isSpecialFunc = isConditionSpecialFunc(layer?.condition);

  const { conditions } = new FilterCondition(
    conditionSplit.filter(item => !item.trim().match(/^!*intersect.*$/)).join(` ${FilterConditionOperation.AND} `),
  );

  if (!layer.condition) {
    return undefined;
  }

  return `${conditions.length + (isSpecialFunc ? 1 : 0)}${isSpecialFunc ? "+" : ""}`;
};
